import React, { useEffect, useState } from 'react';
import { apiCall, currencyFormat } from '../../utils';


const RenderFinancialOverviewTableRow = ({ key, rowData, onlyFranchise }) => {
  let filialNome = '';
  let filialFranquiado = 0;

  if (window._sessionData.businessBranches) {
    // if is object convert to array
    if (!Array.isArray(window._sessionData.businessBranches)) {
      window._sessionData.businessBranches = Object.keys(window._sessionData.businessBranches).map((key) => {
        return window._sessionData.businessBranches[key];
      });
    }
    let filial = window._sessionData.businessBranches.find((branch) => {
      return parseInt(branch.ID) === parseInt(rowData.FILIAL_ID);
    });
    if (filial) {
      filialNome = filial.FILIAL;
      filialFranquiado = parseInt(filial.FRANQUIADO);
    }
  }

  if (onlyFranchise && filialFranquiado == 0 || !onlyFranchise && filialFranquiado == 1) {
    return null;
  }

  //console.log('filialNome', filialNome);
  return (
    <tr key={key} className="text-center">
      <td data-label="Filial">{filialNome}<br /><small className="text-left">Meta: R${rowData.META_FATURAMENTO_VALOR}</small></td>
      <td data-label="PN">{rowData.PN}</td>
      <td data-label="PIT">{rowData.PIT}</td>
      <td data-label="PIM">{rowData.PIM}</td>
      <td data-label="Aproveitamento PNxPIT">{rowData.APROVEITAMENTO_PORCENTAGEM}%</td>
      <td data-label="Meta Aproveitamento">{rowData.META_FATURAMENTO_PORCENTAGEM}%</td>
      <td data-label="Proj. Aproveitamento">{rowData.PROJECAO_META}%</td>
      <td data-label="Cancelamentos QTD">{rowData.CANCELAMNENTOS_QTD_CONTRATOS ?? 0}</td>
      <td data-label="Cancelamentos R$">R${currencyFormat(rowData.CANCELAMNENTOS_VALOR_RESSARCIMENTO ?? 0)}</td>
      <td data-label="Ticket médio p/sessão">
        R${currencyFormat(rowData.TICKET_MEDIO_POR_SESSAO ?? 0)}
      </td>
      <td data-label="Faturamento">
        R${currencyFormat(rowData.FATURAMENTO_ATE_HOJE ?? 0)}<br />
        <small className="text-left">
          Fat. Aprox. PNs: R${currencyFormat(rowData.FATURAMENTO_PN ?? 0)}<br />
          Fat. Aprox. PIMs: R${currencyFormat(rowData.FATURAMENTO_PIM ?? 0)}<br />
          Fat. Aprox. PIT R${currencyFormat(rowData.FATURAMENTO_ATE_HOJE - rowData.FATURAMENTO_PN - rowData.FATURAMENTO_PIM)}<br />
          Fat. Planos Anuais R${currencyFormat(rowData.FATURAMENTO_UPGRADES ?? 0)} ({rowData.UPGRADES ?? 0})
        </small>
      </td>
      <td data-label="Proj. Faturamento">
        R${currencyFormat(rowData.PROJECAO_MENSAL ?? 0)}
      </td>
      <td data-label="Sessões Vendidas">{rowData.SESSOES_VENDIDAS}</td>
      <td data-label="Média PNs por dia">{rowData.MEDIA_PNS_POR_DIA}</td>
      <td data-label="Faturamento Gel">
        R${currencyFormat(rowData.FATURAMENTO_GEL ?? 0)}
      </td>
      <td data-label="Qtd. Venda Gel">{rowData.QTD_VENDA_GEL}</td>
    </tr>
  );
}

const GeneralFinancialOverview = ({
  isTabOpen = false,
  filterData,
  currentXhr,
  setCurrentXhr,
  onlyFranchise = false
}) => {
  const [generalGoal, setGeneralGoal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState({
    table1: []
  })
  const [tableTotals, setTableTotals] = useState({
    table1: {
      PN: 0,
      PIT: 0,
      PIM: 0,
    }
  })

  const fetchFinancialReports = async () => {
    if (currentXhr) {
      currentXhr.abort();
      setCurrentXhr(false);
    }
    let xhr = apiCall({
      method: 'GET',
      endpoint: 'api/v1/reports/financial',
      data: {
        branch: -1,
        startDate: filterData.startDate,
        endDate: filterData.endDate,
        reportType: 'FINANCIAL_OVERVIEW',
        franchise: onlyFranchise
      },
      successCallback: function (res) {
        setIsLoading(false);
        setCurrentXhr(false);
        window.toast({
          error: res.error,
          text: res.message
        })
        if (res.error) {
        } else {
          setTableData({
            table1: res
          });
          setGeneralGoal(res.pontoEquilibrio);
        }
      },
      errorCallback: function (res) {
        setIsLoading(false);
        setCurrentXhr(false);
      }
    })
    setCurrentXhr(xhr);
  }

  useEffect(() => {
    if (isTabOpen) {
      setIsLoading(true);
      //console.log('render called for whole business overview')
      if (filterData.startDate && filterData.endDate) {
        //if (!currentXhr) {
        setTableData({
          table1: []
        });
        fetchFinancialReports();
        //}
      }
    } else {
      setIsLoading(true);
      //console.log('cleanup called for whole business overview')
    }
  }, [isTabOpen, filterData]);

  useEffect(() => {
    //if (onlyFranchise) {
    setIsLoading(true);
    fetchFinancialReports();
    //}
  }, [onlyFranchise]);
  console.log('GeneralOverview', onlyFranchise);

  /*useEffect(() => {
    //console.log('isTabOpen', isTabOpen);
    //console.log('filterData', filterData);
    if (isTabOpen && filterData.startDate && filterData.endDate) {
      setTableData({
        table1: []
      });
      fetchFinancialReports();
    }
  }, [filterData]);*/

  useEffect(() => {
    //console.log('tableData', tableData);

    if (tableData?.table1?.data_contaazul) {
      let totalPN = 0;
      let totalPIT = 0;
      let totalPIM = 0;
      let metaAlcancada = 0;
      let totalSessoes = 0;
      let totalFaturamento = 0;
      let totalFaturamentoPN = 0;
      let totalFaturamentoPIT = 0;
      let totalFaturamentoPIM = 0;
      let projecaoMeta = 0;
      let projecaoFaturamento = 0;
      let ticketMedioPorSessao = 0;
      let ticketMedioReais = 0;
      let aproveitamentoPitPn = 0;

      let mediaPnTotal = 0;
      let mediaPnTotalCount = 0;

      let qtdTotaisContratosCancelados = 0;
      let valorTotaisContratosRessarcidos = 0;

      let totalFaturamentoGel = 0;
      let totalQtdVendaGel = 0;

      tableData.table1.data_contaazul.map((row) => {
        totalPN += row.PN;
        totalPIT += row.PIT;
        totalPIM += row.PIM;
        totalFaturamento += Number(row.FATURAMENTO_ATE_HOJE);
        totalSessoes += Number(row.SESSOES_VENDIDAS);
        metaAlcancada += Number(row.META_FATURAMENTO_PORCENTAGEM);
        projecaoMeta += Number(row.PROJECAO_META);
        projecaoFaturamento += Number(row.PROJECAO_MENSAL);

        totalFaturamentoPN += Number(row.FATURAMENTO_PN ?? 0);
        totalFaturamentoPIT += Number(row.FATURAMENTO_PIT ?? 0);
        totalFaturamentoPIM += Number(row.FATURAMENTO_PIM ?? 0);

        ticketMedioReais += Number(row.TICKET_MEDIO);
        mediaPnTotal += Number(row.MEDIA_PNS_POR_DIA);
        mediaPnTotalCount++;

        qtdTotaisContratosCancelados += Number(row.CANCELAMNENTOS_QTD_CONTRATOS ?? 0);
        valorTotaisContratosRessarcidos += Number(row.CANCELAMNENTOS_VALOR_RESSARCIMENTO ?? 0);

        totalFaturamentoGel += Number(row.FATURAMENTO_GEL ?? 0);
        totalQtdVendaGel += Number(row.QTD_VENDA_GEL ?? 0);
      });

      console.log('tableData.table1.data_contaazul', tableData.table1.data_contaazul);
      console.log('totalFaturamento', totalFaturamento);

      metaAlcancada = metaAlcancada / tableData.table1.data_contaazul.length;
      aproveitamentoPitPn = totalPN == 0 ? 0 : totalPIT * 100 / totalPN;
      ticketMedioPorSessao = totalSessoes == 0 ? 0 : totalFaturamento / totalSessoes;
      ticketMedioReais = ticketMedioReais / tableData.table1.data_contaazul.length;
      projecaoMeta = projecaoMeta / tableData.table1.data_contaazul.length;

      setTableTotals({
        table1: {
          PN: totalPN,
          PIT: totalPIT,
          PIM: totalPIM,
          APROVEITAMENTO: parseFloat(aproveitamentoPitPn).toFixed(2),
          META_PORCENTAGEM: parseFloat(metaAlcancada).toFixed(2),
          META_PROJECAO: parseFloat(projecaoMeta).toFixed(2),
          TICKET_MEDIO_POR_SESSAO: parseFloat(ticketMedioPorSessao).toFixed(2),
          TICKET_MEDIO: parseFloat(ticketMedioReais).toFixed(2),
          TOTAL_FATURAMENTO: parseFloat(totalFaturamento).toFixed(2),
          TOTAL_FATURAMENTO_PN: parseFloat(totalFaturamentoPN).toFixed(2),
          TOTAL_FATURAMENTO_PIT: parseFloat(totalFaturamentoPIT).toFixed(2),
          TOTAL_FATURAMENTO_PIM: parseFloat(totalFaturamentoPIM).toFixed(2),
          PROJECAO_MENSAL: parseFloat(projecaoFaturamento).toFixed(2),
          TOTAL_SESSOES: totalSessoes,
          MEDIA_PNS_POR_DIA: mediaPnTotalCount > 0 ? parseFloat(mediaPnTotal / mediaPnTotalCount).toFixed(2) : 0,
          TOTAL_CANCELAMENTOS_QTD: qtdTotaisContratosCancelados,
          TOTAL_CANCELAMENTOS_VALOR: valorTotaisContratosRessarcidos,
          TOTAL_FATURAMENTO_GEL: parseFloat(totalFaturamentoGel).toFixed(2),
          TOTAL_QTD_VENDA_GEL: totalQtdVendaGel
        }
      });
    }
  }, [tableData]);

  return (
    <>
      <div className="p-2">
        <div className="table-responsive">
          <table className="mb-0 table table-bordered table-striped table-hover responsive-table" style={{ height: 'auto !important' }}>
            <thead>
              <tr key={0}>
                <th className="" colSpan="4">Filial</th>
                <th className="" colSpan="">P.E %</th>
                <th className="" colSpan="">{parseFloat(generalGoal).toFixed(1)}</th>
              </tr>
              <tr key={1}>
                <th className="">Unidade</th>
                <th className="js-mkt-branches-funnel-column-1">PN</th>
                <th className="js-mkt-branches-funnel-column-2">PIT</th>
                <th className="js-mkt-branches-funnel-column-3">PIM</th>
                <th className="js-mkt-branches-funnel-column-4">%</th>
                <th className="js-mkt-branches-funnel-column-5">META %</th>
                <th className="js-mkt-branches-funnel-column-5">Proj. Meta</th>
                <th className="js-mkt-branches-funnel-column-6">Cancelamentos QTD</th>
                <th className="js-mkt-branches-funnel-column-7">Cancelamentos R$</th>
                <th className="js-mkt-branches-funnel-column-8">Ticket Médio (p/sessão)</th>
                <th className="js-mkt-branches-funnel-column-9">Faturamento</th>
                <th className="js-mkt-branches-funnel-column-5">Proj. Fat.</th>
                <th className="js-mkt-branches-funnel-column-10">Sessões Vendidas</th>
                <th className="js-mkt-branches-funnel-column-11">Média de PN/DIA</th>
                <th className="js-mkt-branches-funnel-column-12">Faturamento Gel</th>
                <th className="js-mkt-branches-funnel-column-13">Qtd. Venda Gel</th>
              </tr>
            </thead>
            <tbody className="js-report-marketing-branches-funnel-list">
              {isLoading ? <tr key={0}><td colSpan="17">Carregando...</td></tr> : tableData?.table1?.data_contaazul?.map((row, index) => {
                return <RenderFinancialOverviewTableRow key={index} rowData={row} onlyFranchise={onlyFranchise} />
              })}
            </tbody>
            <tfoot>
              <tr key={0} className="text-center">
                <td><b>Total</b></td>
                <td><b>{tableTotals.table1.PN}</b></td>
                <td><b>{tableTotals.table1.PIT}</b></td>
                <td><b>{tableTotals.table1.PIM}</b></td>
                <td><b>{tableTotals.table1.APROVEITAMENTO}%</b></td>
                <td><b>{tableTotals.table1.META_PORCENTAGEM}%</b></td>
                <td><b>{tableTotals.table1.META_PROJECAO}%</b></td>
                <td><b>{tableTotals.table1.TOTAL_CANCELAMENTOS_QTD}</b></td>
                <td><b>R${currencyFormat(tableTotals.table1.TOTAL_CANCELAMENTOS_VALOR ?? 0)}</b></td>
                <td><b>R${currencyFormat(tableTotals.table1.TICKET_MEDIO_POR_SESSAO ?? 0)}</b></td>
                <td><b>R${currencyFormat(tableTotals.table1.TOTAL_FATURAMENTO ?? 0)}</b></td>
                <td><b>R${currencyFormat(tableTotals.table1.PROJECAO_MENSAL ?? 0)}</b></td>
                <td><b>{tableTotals.table1.TOTAL_SESSOES}</b></td>
                <td><b>{tableTotals.table1.MEDIA_PNS_POR_DIA}</b></td>
                <td><b>R${currencyFormat(tableTotals.table1.TOTAL_FATURAMENTO_GEL ?? 0)}</b></td>
                <td><b>{tableTotals.table1.TOTAL_QTD_VENDA_GEL}</b></td>
              </tr>
              <tr key={1}>
                <td colSpan="15">
                  Faturamento aproximado¹ em PNs: R${currencyFormat(tableTotals.table1.TOTAL_FATURAMENTO_PN ?? 0)}<br />
                  Faturamento aproximado¹ em PITs: R${currencyFormat(tableTotals.table1.TOTAL_FATURAMENTO_PIT ?? 0)}<br />
                  Faturamento aproximado¹ em PIMs: R${currencyFormat(tableTotals.table1.TOTAL_FATURAMENTO_PIM ?? 0)}<br />
                  Faturamento aproximado em Gel: R${currencyFormat(tableTotals.table1.TOTAL_FATURAMENTO_GEL ?? 0)}<br /><br />

                  Dias de funcionamentos até hoje: {tableData.table1.daysDiff ?? 0}<br />
                  Total de dias de funcionamento: {tableData.table1.countTotalDays ?? 0}<br /><br />

                  ¹ Estes valores foram retirados do TheQuiro, podendo haver pagamentos que são parcelados, porém lançados com valor total no dia da venda.<br />
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
}
export default GeneralFinancialOverview;